<template>
  <div>
    <div class="row">
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">SPACE STATS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Space stats"
                  v-b-popover.hover="'This is a compilation of space stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-indigo f-s-8 mr-2"></i>
                Space items
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ spaceCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-purple f-s-8 mr-2"></i>
                Areas
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">{{ areas }}</div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-pink f-s-8 mr-2"></i>
                Venues
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">{{ venues }}</div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Available
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ availableSpaces }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeSpaces }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Balance
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ balanceSpaces }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">STUFF STATS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Stuff stats"
                  v-b-popover.hover="'This is a compilation of stuff stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-blue f-s-8 mr-2"></i>
                Items
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stuffCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-aqua f-s-8 mr-2"></i>
                Subcategories
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ subcategories }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-teal f-s-8 mr-2"></i>
                Categories
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stuffCategories }}
                </div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Available
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 pl-2 f-w-600">
                  {{ availableStuffPcs + ' pcs' }}
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ availableStuffM + ' m' }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 pl-2 f-w-600">
                  {{ activeStuffPcs + ' pcs' }}
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeStuffM + ' m' }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Balance
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 pl-2 f-w-600">
                  {{ balanceStuffPcs + ' pcs' }}
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ balanceStuffM + ' m' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">STAFF STATS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Staff stats"
                  v-b-popover.hover="'This is a compilation of staff stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-green f-s-8 mr-2"></i>
                Staff
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ staffCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-lime f-s-8 mr-2"></i>
                Teams
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">{{ teams }}</div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-yellow f-s-8 mr-2"></i>
                Groups
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">{{ groups }}</div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Available
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ availableStaff }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeStaff }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Balance
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ balanceStaff }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">SERVICE STATS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Service stats"
                  v-b-popover.hover="'This is a compilation of service stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-red f-s-8 mr-2"></i>
                Service providers
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ serviceCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-orange f-s-8 mr-2"></i>
                Service areas
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ serviceAreas }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-yellow f-s-8 mr-2"></i>
                Service Categories
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ serviceCategories }}
                </div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Available
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ availableServices }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeServices }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Balance
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ balanceServices }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-3 col-lg-6 mb-3">
        <!-- begin space card -->
        <b-card
          bg-variant="dark"
          footer-bg-variant="dark"
          text-variant="light"
          title="Space tasks"
          :img-src="
            require('@/assets/images/widget/Widget_card_headpics_EB_space.jpg')
          "
          img-alt="Space Image"
          img-top
        >
          <b-card-text>
            Organize space by venue, area or space items (rooms etc.)
          </b-card-text>
          <url-button class="btn-yellow" label="Select" :url="`/task/space`" />
        </b-card>
        <!-- end space card -->
      </div>
      <div class="col-xl-3 col-lg-6 mb-3">
        <!-- begin stuff card -->
        <b-card
          bg-variant="dark"
          footer-bg-variant="dark"
          text-variant="light"
          title="Stuff tasks"
          :img-src="
            require('@/assets/images/widget/Widget_card_headpics_EB_stuff.jpg')
          "
          img-alt="Stuff Image"
          img-top
        >
          <b-card-text>
            Organize stuff by main category, category items or stuff items
            (products)
          </b-card-text>
          <url-button class="btn-yellow" label="Select" :url="`/task/stuff`" />
        </b-card>
        <!-- end stuff card -->
      </div>
      <div class="col-xl-3 col-lg-6 mb-3">
        <!-- begin staff card -->
        <b-card
          bg-variant="dark"
          footer-bg-variant="dark"
          text-variant="light"
          title="Staff tasks"
          :img-src="
            require('@/assets/images/widget/Widget_card_headpics_EB_staff.jpg')
          "
          img-alt="Staff Image"
          img-top
        >
          <b-card-text>
            Organize staff by staff group, teams or job titles (persons)
          </b-card-text>
          <url-button class="btn-yellow" label="Select" :url="`/task/staff`" />
        </b-card>
        <!-- end staff card -->
      </div>
      <div class="col-xl-3 col-lg-6 mb-3">
        <!-- begin service card -->
        <b-card
          bg-variant="dark"
          footer-bg-variant="dark"
          text-variant="light"
          title="Service tasks"
          :img-src="
            require('@/assets/images/widget/Widget_card_headpics_EB_service.jpg')
          "
          img-alt="Service Image"
          img-top
        >
          <b-card-text>
            Organize service by service category, service area or service items
            (providers)
          </b-card-text>
          <url-button
            class="btn-yellow"
            label="Select"
            :url="`/task/service`"
          />
        </b-card>
        <!-- end service card -->
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4 col-lg-6 mb-3">
        <!-- begin storyboard card -->
        <div class="card bg-dark text-white">
          <div class="card-body">
            <h4 class="card-title">Storyboard tasks</h4>
            <b-card-text>
              Make things happen. View, export or share your storyboards.
            </b-card-text>
            <url-button
              class="btn-yellow"
              label="Select"
              :url="`/task/storyboard`"
            />
          </div>
        </div>
        <!-- end storyboard card -->
      </div>
      <div class="col-xl-4 col-lg-6 mb-3">
        <!-- begin stage card -->
        <div class="card bg-dark text-white">
          <div class="card-body">
            <h4 class="card-title">Stage tasks</h4>
            <b-card-text>
              Make things happen. View, export or share your stages.
            </b-card-text>
            <url-button
              class="btn-yellow"
              label="Select"
              :url="`/task/stage`"
            />
          </div>
        </div>
        <!-- end stage card -->
      </div>
      <div class="col-xl-4 col-lg-6 mb-3">
        <!-- begin step card -->
        <div class="card bg-dark text-white">
          <div class="card-body">
            <h4 class="card-title">Step tasks</h4>
            <b-card-text>
              Make things happen. View, export or share your steps.
            </b-card-text>
            <url-button class="btn-yellow" label="Select" :url="`/task/step`" />
          </div>
        </div>
        <!-- end step card -->
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4 col-lg-6 mb-3">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">STORYBOARDS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Storyboards"
                  v-b-popover.hover="
                    'This is a compilation of storyboard stats'
                  "
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Total
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ storyboardCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeStoryboards }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Stages on average
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stagesInStoryboard }}
                </div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="row align-items-center p-b-1">
              <div class="col-12">
                <div class="m-b-2 text-truncate">Progress</div>
                <div class="d-flex align-items-center m-b-2">
                  <div class="flex-grow-1">
                    <div
                      class="
                        progress progress-xs
                        rounded-corner
                        bg-white-transparent-1
                      "
                    >
                      <div
                        class="progress-bar progress-bar-striped bg-yellow"
                        :style="'width: ' + storyboardProgress + '%'"
                      ></div>
                    </div>
                  </div>
                  <div class="ml-2 f-s-11 width-30 text-center">
                    {{ storyboardProgress }}%
                  </div>
                </div>
                <div class="text-grey f-s-11 m-b-15 text-truncate">
                  Almost there
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-6 mb-3">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">STAGES</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Stages"
                  v-b-popover.hover="'This is a compilation of stage stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Total
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stageCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeStages }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Steps on average
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stepsInStage }}
                </div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="row align-items-center p-b-1">
              <div class="col-12">
                <div class="m-b-2 text-truncate">Progress</div>
                <div class="d-flex align-items-center m-b-2">
                  <div class="flex-grow-1">
                    <div
                      class="
                        progress progress-xs
                        rounded-corner
                        bg-white-transparent-1
                      "
                    >
                      <div
                        class="progress-bar progress-bar-striped bg-yellow"
                        :style="'width: ' + stageProgress + '%'"
                      ></div>
                    </div>
                  </div>
                  <div class="ml-2 f-s-11 width-30 text-center">
                    {{ stageProgress }}%
                  </div>
                </div>
                <div class="text-grey f-s-11 m-b-15 text-truncate">
                  Almost there
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-6 mb-3">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">STEPS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Steps"
                  v-b-popover.hover="'This is a compilation of step stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Total
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stepCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeSteps }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-dark f-s-8 mr-2"></i>
                &shy;
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600"></div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="row align-items-center p-b-1">
              <div class="col-12">
                <div class="m-b-2 text-truncate">Progress</div>
                <div class="d-flex align-items-center m-b-2">
                  <div class="flex-grow-1">
                    <div
                      class="
                        progress progress-xs
                        rounded-corner
                        bg-white-transparent-1
                      "
                    >
                      <div
                        class="progress-bar progress-bar-striped bg-yellow"
                        :style="'width: ' + stepProgress + '%'"
                      ></div>
                    </div>
                  </div>
                  <div class="ml-2 f-s-11 width-30 text-center">
                    {{ stepProgress }}%
                  </div>
                </div>
                <div class="text-grey f-s-11 m-b-15 text-truncate">
                  Almost there
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UrlButton from '../buttons/UrlButton.vue'

export default {
  name: 'TaskIndex',
  components: {
    UrlButton
  },
  props: [
    'storyboards',
    'stages',
    'steps',
    'activeEvent',
    'items',
    'categories',
    'scriptItems'
  ],
  data() {
    return {
      loaded: false,
      serviceCount: 0,
      serviceAreas: 0,
      serviceCategories: 0,
      spaceCount: 0,
      areas: 0,
      venues: 0,
      staffCount: 0,
      teams: 0,
      groups: 0,
      stuffCount: 0,
      subcategories: 0,
      stuffCategories: 0,
      storyboardCount: 0,
      activeStoryboards: 0,
      stagesInStoryboard: 0,
      storyboardProgress: 0,
      stageCount: 0,
      activeStages: 0,
      stepsInStage: 0,
      stageProgress: 0,
      stepCount: 0,
      activeSteps: 0,
      stepProgress: 0,
      availableSpaces: 0,
      availableStuffPcs: 0,
      availableStuffM: 0,
      availableStaff: 0,
      availableServices: 0,
      activeSpaces: 0,
      activeStuffPcs: 0,
      activeStuffM: 0,
      activeStaff: 0,
      activeServices: 0,
      balanceSpaces: 0,
      balanceStuffPcs: 0,
      balanceStuffM: 0,
      balanceStaff: 0,
      balanceServices: 0
    }
  },
  methods: {
    getScriptCounts() {
      let stepsCounted = false
      this.storyboards.forEach((storyboard) => {
        if (storyboard.event == this.activeEvent.id) {
          this.storyboardCount++
          storyboard.stages.forEach((storyboardStage) => {
            let currentActiveStages = 0
            this.stages.forEach((stage) => {
              if (stage.id == storyboardStage.id) {
                this.stageCount++
                let currentActiveSteps = 0
                this.steps.forEach((step) => {
                  if (!stepsCounted) {
                    this.stepCount++
                  }
                  if (step.stage == stage.id) {
                    let currentStepProgress = 0
                    if (step.service) {
                      currentStepProgress += 25
                    }
                    if (step.space) {
                      currentStepProgress += 25
                    }
                    if (step.staff) {
                      currentStepProgress += 25
                    }
                    if (step.stuff) {
                      currentStepProgress += 25
                    }

                    if (currentStepProgress == 100) {
                      this.stepsStarted++
                      this.activeSteps++
                      currentActiveSteps++
                    } else if (currentStepProgress != 0) {
                      this.stepsStarted++
                    }
                  }
                })
                stepsCounted = true
                if (
                  currentActiveSteps == stage.steps.length &&
                  currentActiveSteps != 0
                ) {
                  this.activeStages++
                  currentActiveStages++
                }
              }
            })
            if (
              currentActiveStages == storyboard.stages.length &&
              currentActiveStages != 0
            ) {
              this.activeStoryboards++
            }
          })
        }
        this.stagesInStoryboard = (
          this.stageCount / this.storyboardCount
        ).toFixed(1)
        this.storyboardProgress = (
          (this.activeStoryboards / this.storyboardCount) *
          100
        ).toFixed(1)
        this.stepsInStage = (this.stepCount / this.stageCount).toFixed(1)
        this.stepProgress = ((this.activeSteps / this.stepCount) * 100).toFixed(
          1
        )
        this.stageProgress = (
          (this.activeStages / this.stageCount) *
          100
        ).toFixed(1)
      })
    },
    getBankCounts() {
      let totalSpaces = 0,
        totalStuffPcs = 0,
        totalStuffM = 0,
        totalStaff = 0,
        totalServices = 0
      this.items.forEach((item) => {
        let currentAmountInUse = 0
        this.scriptItems.forEach((scriptItem) => {
          if (scriptItem.item.id == item.id) {
            currentAmountInUse += scriptItem.amount
            switch (item.type.id) {
              case 1:
                this.activeServices += scriptItem.amount
                break
              case 2:
                this.activeSpaces += scriptItem.amount
                break
              case 3:
                this.activeStaff += scriptItem.amount
                break
              case 4:
                if (item.unit == 'm') {
                  this.activeStuffM += scriptItem.amount
                } else {
                  this.activeStuffPcs += scriptItem.amount
                }
                break
              default:
                break
            }
          }
        })
        let currentItemBalance = item.amount - currentAmountInUse
        if (currentItemBalance > 0) {
          switch (item.type.id) {
            case 1:
              this.availableServices += currentItemBalance
              break
            case 2:
              this.availableSpaces += currentItemBalance
              break
            case 3:
              this.availableStaff += currentItemBalance
              break
            case 4:
              if (item.unit == 'm') {
                this.availableStuffM += currentItemBalance
              } else {
                this.availableStuffPcs += currentItemBalance
              }
              break
          }
        }

        switch (item.type.id) {
          case 1:
            this.serviceCount++
            totalServices += item.amount
            break
          case 2:
            this.spaceCount++
            totalSpaces += item.amount
            break
          case 3:
            this.staffCount++
            totalStaff += item.amount
            break
          case 4:
            this.stuffCount++
            if (item.unit == 'm') {
              totalStuffM += item.amount
            } else {
              totalStuffPcs += item.amount
            }
            break
          default:
            break
        }
      })
      this.balanceServices = totalServices - this.activeServices
      this.balanceSpaces = totalSpaces - this.activeSpaces
      this.balanceStaff = totalStaff - this.activeStaff
      this.balanceStuffM = totalStuffM - this.activeStuffM
      this.balanceStuffPcs = totalStuffPcs - this.activeStuffPcs

      this.categories.forEach((category) => {
        if (category.parent) {
          switch (category.type.id) {
            case 1:
              this.serviceAreas++
              break
            case 2:
              this.areas++
              break
            case 3:
              this.teams++
              break
            case 4:
              this.subcategories++
              break
            default:
              break
          }
        } else {
          switch (category.type.id) {
            case 1:
              this.serviceCategories++
              break
            case 2:
              this.venues++
              break
            case 3:
              this.groups++
              break
            case 4:
              this.stuffCategories++
              break
            default:
              break
          }
        }
      })
    }
  },
  watch: {
    categories: function () {
      if (!this.loaded) {
        this.getScriptCounts()
        this.getBankCounts()
        this.loaded = true
      }
    }
  }
}
</script>
